export default (Vue) => {
  Vue.filter('filesize', (value) => {
    if (!value) return value
    return humanFileSize(value, true)
  })

  // https://stackoverflow.com/questions/16023824/how-do-i-format-bytes-to-human-readable-text-in-javascript
  function humanFileSize (bytes, si) {
    const thresh = si ? 1000 : 1024
    if (bytes < thresh) return bytes + ' B'
    const units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
    let u = -1
    do {
      bytes /= thresh
      ++u
    } while (bytes >= thresh)
    return bytes.toFixed(1) + ' ' + units[u]
  }
}



// WEBPACK FOOTER //
// ./src/filters/filesize.js